import { Reveal } from "@components/ui";

/* ─── Data ─── */

const moveInSteps = [
  { label: "Account Setup", color: "#f24d2b" },
  { label: "Smart Meter Activation", color: "#122d63" },
  { label: "Security Deposit", color: "#0d9488" },
  { label: "First Bill After 1 Month", color: "#7c3aed" },
];

const moveOutSteps = [
  { label: "Final Meter Reading", color: "#f24d2b" },
  { label: "Final Bill Issued", color: "#122d63" },
  { label: "Deposit Refund (7–10 days)", color: "#0d9488" },
  { label: "Account Closed", color: "#62636c" },
];

function TimelineGroup({ title, titleColor, bgColor, steps }: { title: string; titleColor: string; bgColor: string; steps: { label: string; color: string }[] }) {
  return (
    <div className="rounded-[20px] md:rounded-[24px] p-6 md:p-8 lg:p-10" style={{ backgroundColor: bgColor }}>
      <h3
        className="text-[20px] md:text-[26px] lg:text-[32px] tracking-[-0.04em] font-semibold font-albert-sans leading-[1.1] mb-6 md:mb-8"
        style={{ color: titleColor }}
      >
        {title}
      </h3>
      <div className="flex flex-col gap-0">
        {steps.map((step, index) => (
          <div key={step.label} className="flex items-start gap-4">
            {/* Timeline line + dot */}
            <div className="flex flex-col items-center">
              <div
                className="w-4 h-4 md:w-5 md:h-5 rounded-full shrink-0 mt-0.5"
                style={{ backgroundColor: step.color }}
              />
              {index < steps.length - 1 && (
                <div className="w-[2px] h-10 md:h-14 bg-[#e0e1e6]" />
              )}
            </div>

            {/* Label */}
            <span className="text-[14px] md:text-[16px] lg:text-[18px] tracking-[-0.04em] text-[#1c1c1c] font-albert-sans font-medium">
              {step.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ─── Component ─── */

export function BillingMovingSection() {
  return (
    <section className="w-full bg-white py-12 md:py-16 lg:py-[120px] px-5 md:px-10 lg:px-[180px]">
      <div className="w-full max-w-[1368px] mx-auto">
        {/* Header */}
        <Reveal direction="up">
          <div className="flex flex-col items-center gap-3 md:gap-4 mb-10 md:mb-14">
            <span className="inline-block px-4 py-1.5 rounded-full bg-[#f24d2b]/10 text-[#f24d2b] text-[13px] font-semibold tracking-[-0.02em] uppercase">
              Moving Guide
            </span>
            <h2 className="text-center text-[28px] md:text-[44px] lg:text-[60px] tracking-[-0.04em] font-semibold text-[#122d63] leading-[1.1]">
              What Happens When You Move?
            </h2>
          </div>
        </Reveal>

        {/* Two columns */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16">
          <Reveal direction="up">
            <TimelineGroup title="Move In" titleColor="#0d9488" bgColor="#f0fdfa" steps={moveInSteps} />
          </Reveal>
          <Reveal direction="up" delay={150}>
            <TimelineGroup title="Move Out" titleColor="#f24d2b" bgColor="#fef2f0" steps={moveOutSteps} />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
